/*
 * the module's tab list, kept I/O-free so the shell and the badge adapter can be pinned to the
 * same keys (deleted "Session review"; a badge for a tab that is gone is invisible).
 */
export const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'needs-attention', label: 'Needs attention' },
  { key: 'penalties', label: 'Penalties' },
  { key: 'additional-payments', label: 'Additional payments' },
  { key: 'reports', label: 'Reports' },
  { key: 'close-versions', label: 'Close versions' },
  { key: 'email-logs', label: 'Email logs' },
  { key: 'payment-details', label: 'Payment details' },
  { key: 'invoices', label: 'Invoices' },
  { key: 'bank-payouts', label: 'Bank payouts' },
  { key: 'payment-emails', label: 'Payment emails' },
  { key: 'rules-engine', label: 'Rules' },
  { key: 'audit', label: 'Audit trail', hidden: true }
];

export const TAB_KEYS = TABS.map((t) => t.key);

// The tabs that read a real month.
export const MONTH_TABS = [
  'overview',
  'needs-attention',
  'penalties',
  'additional-payments',
  'reports',
  'close-versions',
  'email-logs',
  'invoices',
  'bank-payouts'
];

// no header month picker here; the rules have no month and the audit trail filters its own. payment
// details and the payment email history are not per month either.
export const NO_MONTH_PICKER_TABS = ['audit', 'rules-engine', 'payment-details', 'payment-emails'];

// Twelve tabs overflowed a laptop, so they sit in three groups; the group is derived from the tab key
// (never stored), so every /teacher-payments/<key> deep link still lands.
export const TAB_GROUPS = [
  {
    key: 'month',
    label: 'Month',
    tabs: ['overview', 'needs-attention', 'penalties', 'additional-payments', 'close-versions']
  },
  {
    key: 'paying',
    label: 'Paying teachers',
    tabs: ['payment-details', 'invoices', 'bank-payouts', 'payment-emails', 'email-logs']
  },
  { key: 'setup', label: 'Setup', tabs: ['rules-engine', 'reports', 'audit'] } // hidden audit: opened from Reports
];

// The group a tab key belongs to; an unknown key falls back like the shell does, to Overview's.
export const group_of_tab = (tab_key) =>
  (TAB_GROUPS.find((g) => g.tabs.indexOf(tab_key) !== -1) || TAB_GROUPS[0]).key;

const ALL_TABS = () => true;

// The tab-bar entries of a group, in the group's order (hidden tabs are routable, never listed).
// allowed(key) drops tabs this user may not see (shared/bank_access.js tab_allowed_for).
export const tabs_of_group = (group_key, allowed = ALL_TABS) => {
  const group = TAB_GROUPS.find((g) => g.key === group_key);
  if (!group) return [];
  return group.tabs
    .map((k) => TABS.find((t) => t.key === k))
    .filter((t) => t && !t.hidden && allowed(t.key));
};

// Where a group click goes: its first listed tab.
export const first_tab_of_group = (group_key, allowed = ALL_TABS) => {
  const listed = tabs_of_group(group_key, allowed);
  return listed.length ? listed[0].key : 'overview';
};

// A group's badge is the sum of its listed tabs' counts, so nothing waiting is hidden by a collapsed group.
export const group_badges = (tab_counts, allowed = ALL_TABS) => {
  const counts = tab_counts || {};
  return TAB_GROUPS.reduce((acc, g) => {
    acc[g.key] = tabs_of_group(g.key, allowed).reduce((sum, t) => {
      const n = Number(counts[t.key]);
      return sum + (Number.isFinite(n) && n > 0 ? n : 0);
    }, 0);
    return acc;
  }, {});
};
